module.exports = __webpack_public_path__ + "img/woman.f5241e62.png";